<script lang="ts">
  import GroupDetailContent from './GroupDetailContent.svelte';

  interface Props {
    open: boolean;
    groupId: string;
    initialSearchQuery?: string;
    justCreated?: boolean;
    onClose: () => void;
  }

  let { open, groupId, initialSearchQuery, justCreated, onClose }: Props =
    $props();

  let dialog = $state<HTMLDialogElement>();

  $effect(() => {
    if (!dialog) return;
    if (open && !dialog.open) {
      dialog.showModal();
      document.documentElement.inert = true;
      document.documentElement.classList.add('noscroll');
      dialog.inert = false;
    } else if (!open && dialog.open) {
      dialog.close();
      document.documentElement.inert = false;
      document.documentElement.classList.remove('noscroll');
    }
  });

  $effect(() => {
    return () => {
      document.documentElement.inert = false;
      document.documentElement.classList.remove('noscroll');
    };
  });

  const handleDelete = () => {
    onClose();
  };
</script>

<dialog
  bind:this={dialog}
  onclick={(e) => e.target === dialog && onClose()}
  oncancel={(e) => {
    e.preventDefault();
    onClose();
  }}
>
  <div class="dialog-header">
    <button class="close-btn" onclick={onClose} aria-label="Lukk">×</button>
  </div>
  <div class="dialog-content">
    <GroupDetailContent
      {groupId}
      {initialSearchQuery}
      {justCreated}
      {onClose}
      onDelete={handleDelete}
    />
  </div>
</dialog>

<style>
  dialog {
    box-sizing: border-box;
    padding: 0;
    width: 90vw;
    max-width: 1200px;
    max-height: 90vh;
    border-radius: var(--radius-lg);
    box-shadow: 0 10px 25px var(--shadow-md);
    background-color: var(--surface-raised);
    color: var(--text);
    border: 1px solid var(--border-strong);
    margin: auto;
    overflow: hidden;
  }

  dialog[open] {
    display: flex;
    flex-direction: column;
  }

  dialog::backdrop {
    background-color: var(--color-backdrop);
    backdrop-filter: blur(2px);
  }

  .dialog-header {
    display: flex;
    justify-content: flex-end;
    padding: var(--space-3) var(--space-4);
    flex-shrink: 0;
  }

  .close-btn {
    background: var(--surface-raised);
    border: 1px solid var(--border-strong);
    color: var(--text-muted);
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    font-size: var(--text-lg);

    &:hover {
      background: var(--border-strong);
      color: var(--text);
    }
  }

  /* Flex column so the content can shrink and let its lists scroll; the
     overflow here is only a fallback for very short viewports. */
  .dialog-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    padding: 0 var(--space-4) var(--space-4);
    overflow-y: auto;
  }
</style>
